import FeaturesAiV2 from './FeaturesAiV2'
export default FeaturesAiV2
